import React, { Fragment } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Spirituality = () => {

    return (
        <Fragment>
            <Header />
            <div class="breadcumb-wrapper" style={{ background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),  url('/assets/img/added/ban.jpg')" }}>
                <div class="container z-index-common">
                    <div class="breadcumb-content">
                        <h1 class="breadcumb-title">Spirituality</h1>
                        <div class="breadcumb-menu-wrap">
                            <ul class="breadcumb-menu">
                                <li><a href="/">Home</a></li>
                                <li>Spirituality</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section class="space">
                <div class="container">
                    <div class="row align-items-center sprituality-box">
                        <div class="col-lg-12">
                            <div class="about-content sprituality-content text-center">
                                <div class="title-area">
                                    <span class="sec-subtitle">Exploring India`s Spiritual Heart</span>
                                    <h2 class="sec-title h1">Slow down. Breathe. Listen.</h2>
                                    <p class="sec-text">There`s something about being in places that are quiet, old, and full of presence. Our spiritual journeys are not just about visiting temples or going through rituals they`re about giving yourself space to pause and reconnect with what matters.</p>
                                    <p class="sec-text">You don`t need to follow a specific path or belief system to join us. This is for anyone who feels drawn to explore the deeper side of life in a country where spirituality is still a living, breathing part of daily life.</p>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="image-box1">
                                <img class="img1" src="assets/img/added/spiri.png" alt="image1" />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="about-content sprituality-content">
                                <div class="title-area">
                                    <p class="sec-text"><b>What to Expect</b></p>
                                    <p class="sec-text">We take you to places that are known for their calm and energy ancient temples, riverside ghats, forest ashrams, and small mountain villages. You might sit for a morning chant in a 500 year old temple, talk to a wandering sadhu, or simply share chai with locals who live their spirituality quietly, every day.</p>
                                    <p class="sec-text">There’s no pressure to participate in anything you're not comfortable with. This isn’t a strict retreat. It's a journey where you observe, listen, feel — and take from it what you need.</p>
                                </div>
                                <p class="sec-text"><b>Who Is This For?</b></p>
                                <ul class="about-list1">
                                    <li>People looking for quiet, personal experiences</li>
                                    <li>Those curious about India`s spiritual traditions</li>
                                    <li>Anyone feeling disconnected, overwhelmed, or simply open to something different</li>
                                    <li>Travelers who prefer simple places over tourist-heavy spots</li>
                                </ul>
                                <a href="destination" class="vs-btn style4">Know More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

           
            <Footer />
        </Fragment>
    );
}

export default Spirituality;